import { Autocomplete, Box, TextField } from '@mui/material'
import React, { useState } from 'react'
import { type Country } from 'services'
import { useCountriesLuts } from '../common/hooks/use-luts-hook'

export interface CountryMultipleSelectorProps {
  value: Country[]
  handleCountryChange: (country: Country[]) => void
}
export const CountryMultipleSelector: React.FC<CountryMultipleSelectorProps> = ({ value, handleCountryChange }) => {
  const { lutValues: countriesLutValues } = useCountriesLuts()
  const [inputValue, setInputValue] = useState('')

  const handleCountrySelection = (event: React.ChangeEvent<any>, value: Country[]): void => {
    handleCountryChange(value)
  }

  return (
    <div>
      <Autocomplete
        id="country-select-demo"
        options={countriesLutValues.countries}
        multiple={true}
        getOptionLabel={(option) => option.country_desc}
        renderOption={(props, option) => (
          <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            {option.country_desc}
          </Box>
        )}
        value={value}
        onChange={handleCountrySelection}
        inputValue={inputValue}
        onInputChange={(event: React.ChangeEvent<any>, value: string) => { setInputValue(value) }}
        autoHighlight
        renderInput={(params) => (
          <TextField
            {...params}
            label="Choose a country"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password' // disable autocomplete and autofill
            }}
          />
        )}
      />
    </div>
  )
}
